/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/QaItpLibraryNameDialog.tsx
 * FILE_ID: JOBHUB-QA-ITP-LIBRARY-NAME-DIALOG-001
 * PURPOSE: Ask for the saved ITP name. Phone uses the existing sheet so it sits above other sheets.
 */
import { createPortal } from 'react-dom'
import { MobileSheet, useIsMdUp } from '@quotech/ui'

export function QaItpLibraryNameDialog({
  open,
  defaultName,
  busy,
  error,
  onCancel,
  onSave,
}: {
  open: boolean
  defaultName: string
  busy: boolean
  error: string | null
  onCancel: () => void
  onSave: (name: string) => void
}) {
  const desktop = useIsMdUp()
  if (!open) return null
  const form = (
    <form
      id="qa-itp-library-name-form"
      onSubmit={(event) => {
        event.preventDefault()
        const data = new FormData(event.currentTarget)
        onSave(String(data.get('name') ?? ''))
      }}
    >
      {desktop ? <h2 id="qa-itp-library-name-title" className="text-sm font-semibold">Save ITP</h2> : null}
      <label className="mt-3 block text-sm">
        ITP name
        <input
          name="name"
          autoFocus
          maxLength={200}
          defaultValue={defaultName}
          className="mt-1 w-full rounded-md border border-border bg-background px-2 py-1 text-base"
        />
      </label>
      {error ? <p className="mt-2 text-xs text-destructive">{error}</p> : null}
    </form>
  )
  const actions = (
    <div className="flex justify-end gap-2">
      <button type="button" onClick={onCancel} className="rounded-md border border-border px-2 py-1 text-xs">Cancel</button>
      <button type="submit" form="qa-itp-library-name-form" disabled={busy} className="rounded-md bg-primary px-2.5 py-1 text-xs font-medium text-primary-foreground disabled:opacity-50">
        {busy ? 'Saving…' : 'Save'}
      </button>
    </div>
  )
  if (!desktop) {
    return (
      // Reused from: packages/ui/src/mobile/MobileSheet.tsx (MobileSheet)
      <MobileSheet open title="Save ITP" onClose={onCancel} size="auto" footer={actions}>
        <div className="p-4">{form}</div>
      </MobileSheet>
    )
  }
  return createPortal(
    <div className="fixed inset-0 z-[65] flex items-center justify-center bg-background/70 p-4" role="presentation">
      <div role="dialog" aria-labelledby="qa-itp-library-name-title" className="w-full max-w-md rounded-xl border border-border bg-card p-4">
        {form}
        <div className="mt-3">{actions}</div>
      </div>
    </div>,
    document.body,
  )
}
